// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import React from "react";
// Assets
import { MdUpload } from "react-icons/md";
import Dropzone from "views/admin/profile/components/Dropzone";

export default function Upload(props) {
  const { used, total, ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";
  return (
    <Card {...rest} mb='20px' align='cnter' p='20px'>
      <Flex h='40%' direction={{ base: "column", "2xl": "row" }} justify='flex-end'>
        <Dropzone   
          w={{ base: "max-content" }}
          h={{ base: "max-content" }}
          mr='0px'
          justify='flex-end'
          content={
            <Box >
              <Icon as={MdUpload} w='30px' h='30px' color="#86DED0" />
              
            </Box>
          }
        />
      
      </Flex>
    </Card>
  );
}
